export const BRAND_NAME = "P4 Fertility";
export const BRAND_COLOR_LIGHT = "rgb(0,184,222)";
export const BRAND_COLOR_DARK = "rgb(1,46,111)";
export const GYNAE_BRAND_NAME = "P4 Gynaecare";
export const GYNAE_BRAND_COLOR_DARK = "rgb(148,33,97)";
